import React from "react";

export const RewardsProgramSection: React.FC = () => {
  return (
    <div>
      <div className="hidden lg:block mt-24">
        <section className="w-full flex justify-center">
      <div className="w-full max-w-[1700px] ">

        {/* container */}
        <div className="relative bg-[#f7f7f7] rounded-[40px] py-[65px] overflow-hidden">

          {/* decorative wave background */}
          <img
            src="/images/Webp/RewardsProgramBG.webp"
            className="absolute inset-0 opacity-40 w-full h-full object-cover pointer-events-none"
            alt=""
          />

          {/* content */}
          <div className="relative z-10 flex flex-col items-center text-center px-[80px] ">

            {/* label */}
            <div className="flex items-center gap-3 mb-4">
              <div className="w-[10px] h-[10px] bg-red-600 rounded-full" />
              <span className="text-gray-600 text-lg font-medium">
                Rewards Program
              </span>
            </div>

            {/* heading */}
            <h2 className="text-[48px] leading-[60px] font-semibold text-black mb-4">
              Rewards for <br />
              Supporting Local
            </h2>

            {/* subtitle */}
            <p className="text-gray-600 text-lg max-w-[500px] mb-16">
              Get rewarded for supporting local. Earn Coupon Points on eligible purchases and turn everyday spending into future savings.
            </p>

            {/* cards row */}
            <div className="flex items-center justify-center gap-4 w-full">

              {/* FREE card */}
              <div className="bg-[#f1e6e6] rounded-full px-[40px] py-[30px] w-[520px] flex text-left items-center justify-center">
                <div className="my-3 w-[380px] items-center justify-center">
                  <div className="flex items-center justify-between ">
                    <h3 className="text-2xl font-semibold">Free</h3>

                    <div className="bg-red-600 text-white text-sm px-4 py-2 rounded-full">
                      Up to 300 points per redemption
                    </div>
                  </div>

                  <p className="font-medium mb-2">
                    Start Earning Today
                  </p>

                  <p className="text-gray-600">
                    It's completely free to start collecting points. Shop around your city, redeem special offers, and watch your points balance grow.
                  </p>
                </div>
              </div>


              {/* center circle */}
              <div className="w-[180px] h-[180px] rounded-full border border-solid border-red-600 flex items-center justify-center">
                <img
                  src="/images/StarPlusIcon.svg"
                  className="
                    w-[80px]
                    h-[80px]
                    rounded-[15px]
                    object-cover
                    border-2 border-white
                  "
                />
                {/* <div className="w-[60px] h-[2px] bg-red-300 absolute" />
                <div className="h-[60px] w-[2px] bg-red-300 absolute" /> */}

              </div>


              {/* PREMIUM card */}
              <div className="bg-gradient-to-r from-red-600 to-red-800 rounded-full px-[40px] py-[30px] w-[520px] flex text-left items-center justify-center">
                <div className="my-3 w-[380px] items-center justify-center">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-white text-2xl font-semibold">Premium</h3>

                    <div className="bg-white text-black text-sm px-4 py-2 rounded-full">
                      🔒 Unlock your points
                    </div>
                  </div>

                  <p className="text-white font-medium mb-2">
                    Unlock to Spend
                  </p>

                  <p className="text-white/90">
                    Built up a great balance? Join Premium when you're ready to unlock those points and spend them directly on the deals you love.
                  </p>

                </div>
              </div>
            </div>

          </div>

        </div>

      </div>
    </section>
      </div>

      <div className=" lg:hidden">
         <section className="w-full flex justify-center">
      <div className="w-full max-w-[1700px]">

        <div className="relative bg-[#f7f7f7] rounded-[30px] sm:rounded-[40px] py-[40px] sm:py-[65px] overflow-hidden">

          {/* BG */}
          <img
            src="/images/Webp/RewardsProgramBG.webp"
            className="absolute opacity-50 inset-0 w-full h-full object-cover pointer-events-none"
            alt=""
          />

          {/* CONTENT */}
          <div className="relative z-10 flex flex-col items-center text-center px-6 sm:px-[80px]">

            {/* LABEL */}
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
              <div className="w-[10px] h-[10px] sm:w-[10px] sm:h-[10px] bg-red-600 rounded-full" />
              <span className="text-gray-600 text-[18px] sm:text-lg font-medium">
                Rewards Program
              </span>
            </div>

            {/* HEADING */}
            <h2 className="text-[28px] leading-[36px] sm:text-[48px] sm:leading-[60px] font-semibold text-black mb-3 sm:mb-4">
              Rewards for Supporting Local
            </h2>

            {/* SUBTEXT */}
            <p className="text-gray-600 text-sm sm:text-lg max-w-[500px] px-6 mb-10 sm:mb-16">
              Get rewarded for supporting local. Earn Coupon Points on eligible purchases and turn everyday spending into future savings.
            </p>

            {/* CARDS */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 w-full ">

              {/* FREE CARD */}
              <div className="w-full sm:w-[520px] bg-[#f1e6e6] rounded-full sm:rounded-full px-10 sm:px-[40px] py-6 sm:py-[30px] text-left">

                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-[20px] sm:text-2xl font-semibold">Free</h3>

                  <div className="bg-red-600 text-white text-xs sm:text-sm px-3 py-1.5 rounded-full whitespace-nowrap">
                    Up to 300 points per redemption
                  </div>
                </div>

                <p className="font-medium mb-1 text-[14px] sm:text-base">
                  Start Earning Today
                </p>

                <p className="text-gray-600 text-[11px] sm:text-base">
                  It's completely free to start collecting points. Shop around your city, redeem special offers, and watch your points balance grow.
                </p>
              </div>


              {/* ❌ HIDE CENTER ICON ON MOBILE */}
              <div className="hidden sm:flex w-[180px] h-[180px] rounded-full border border-red-600 items-center justify-center">
                <img
                  src="/images/StarPlusIcon.svg"
                  className="w-[80px] h-[80px]"
                />
              </div>


              {/* PREMIUM CARD */}
              <div className="w-full sm:w-[520px] bg-gradient-to-r from-red-600 to-red-800 rounded-full sm:rounded-full px-10 sm:px-[40px] py-6 sm:py-[30px] text-left">

                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-white text-[20px] sm:text-2xl font-semibold">
                    Premium
                  </h3>

                  <div className="bg-white text-black text-xs sm:text-sm px-3 py-1.5 rounded-full whitespace-nowrap">
                    🔒 Unlock your points
                  </div>
                </div>

                <p className="text-white font-medium mb-1 text-sm sm:text-base">
                  Unlock to Spend
                </p>

                <p className="text-white/90 text-[11px] sm:text-base">
                  Built up a great balance? Join Premium when you're ready to unlock those points and spend them directly on the deals you love.
                </p>

              </div>

            </div>

          </div>
        </div>
      </div>
    </section>
      </div>
    </div>
    
  );
};